<template>
<div>

  <!-- SEARCH -->
  <section>
    <b-field position="is-centered">
        <b-input v-model="searchstring" placeholder="Search..." type="search" icon="magnify">
        </b-input>
        <!-- <p class="control">
            <button class="button is-info" @click="filterLocally">
              Search
            </button>
        </p>
<p class="control">
            <button class="button is-info" @click="sortLocally">Sort</button>
        </p> -->

      <b-tooltip label="filter"
            :delay="500" position="is-bottom">
        <b-button
              @click="filterLocally"
              icon-left="fas fa-search"
              type="is-primary">
            <!-- Search  -->
          </b-button>
      </b-tooltip>

      <b-tooltip label="Sort value up"
            :delay="500" position="is-bottom">
          <b-button
              @click="sortLocally"
              icon-left="fas fa-sort-amount-up"
              type="is-primary">
            <!-- Search  -->
          </b-button>
      </b-tooltip>
 
    </b-field>
  </section>
  <br>

  <b-notification :closable="false" v-if="!allContacts.length">
      Loading Contacts
      <b-loading :is-full-page="false" :active.sync="!allContacts.length" :can-cancel="true"></b-loading>
  </b-notification>

  <div v-for="contact in myfilteredContacts" v-bind:key="contact.id">
  <!-- <div v-for="contact in filteredContacts" v-bind:key="contact.id"> -->
    <a  @click="putSelectedContact(contact)" >
      <ListPanelItem :contact='contact' style="margin-bottom: 1em;"/>
    </a>
  </div>




</div>
</template>





<script>
import ListPanelItem from '@/components/main/contact/ListPanelItem.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  

  name: 'ListPanelFilter',
  components: {
    ListPanelItem
  },
  

  props: [
  
  ],
  data () {
    return {
      searchstring: "",
      myfilteredContacts: [],
      selected: null, //..by select UI
      localAllContacts: []
    }
  },
  created () {
    
    // this.fetchContacts() 
    this.localAllContacts = JSON.parse(JSON.stringify(this.allContacts))  //..making a copy (by parsing JSON )
      
  },
  computed: {
    ...mapGetters(['allContacts', 'selectedContact']),
    // contactFromIndex () {
    //   return this.allContacts.find(contact => contact.id === this.selected)
    // },
  },
  methods: {
    ...mapActions(['fetchContacts', 'putSelectedContact']),
    onFilterContacts() {
      // this.myfilteredContacts = this.filteredContacts('net')
      this.fetchFilteredContacts(this.searchstring)
    },
    // onSelectChange() {
    //   // console.log("triggerd")
    //   this.putSelectedContact(this.selected)
    // },
    // reloadContacts() {
    //   console.log("reload contacts")
    //   this.fetchContacts()
    // },
    // printAll() {
    //   var c = null
    //   for (c of this.allContacts) {
    //     console.log(c.id + " | "+ JSON.stringify(c.status))
    //   }
    // },
    filterLocally() {
      console.log("filterLocally: "+this.searchstring+ "  "+this.localAllContacts.length)

      this.myfilteredContacts = this.localAllContacts.filter(
        contact => contact.displayName.toLowerCase().includes(this.searchstring.toLowerCase())
        )

      // this.myfilteredContacts = this.allContacts.filter(
      //   contact => contact.name.toLowerCase().includes(this.searchstring.toLowerCase())
      //   )
      

      // this.myfilteredContacts = []
      // console.log("filterLocally: "+this.searchstring+ "  "+this.allContacts.length)
      // this.myfilteredContacts.push.apply(this.myfilteredContacts,  
      //   this.allContacts.filter(contact => contact.name.toLowerCase().includes(this.searchstring.toLowerCase()))
      // )
      // this.myfilteredContacts.push.apply(this.myfilteredContacts,
      //   this.allContacts.filter(contact => 
      //     contact.tags.filter(tag => tag.toLowerCase().includes(this.searchstring.toLowerCase())) 
      //   )
      // )

      // this.myfilteredContacts.push.apply(this.myfilteredContacts,  
      //   this.allContacts.filter(contact => contact.name.toLowerCase().includes(this.searchstring.toLowerCase()))
      // )
      // this.myfilteredContacts = filterByValue()

      // this.myfilteredContacts = this.allContacts.filter(contact => contact.id === parseInt(this.searchstring))
      // this.myfilteredContacts = this.allContacts.filter(contact => contact.name.toLowerCase() === this.searchstring)
    
    // console.log("filterLocally: "+JSON.stringify(this.myfilteredContacts))
    },
    sortLocally() {
      this.myfilteredContacts = this.localAllContacts.sort(function(a,b){return b.status.custtotal - a.status.custtotal})
    }

    // selectcontact(contact) {
    //   //  $store.commit('setSelectedContact', contact) //..calling mutataion -> changing state
    //   this.putSelectedContact(contact) //.. from mapAction

    //   // this.selected = contact.id;
    //   // this.$emit('input', this.selectedContact)
    // },
    // onChange () {
    //   // store.commit('setSelectedContact', this.selectedContact) //..calling mutataion -> changing state
    //   this.putSelectedContact(this.contactFromIndex)

    //   // this.$emit('input', this.selectedContact)
    //   // this.$emit('xxx', this.selectedContact)
    // }
  },
  watch: {
    allContacts (newValue) {
      //...make a copy of the object (even working with the original Object, it's needed) !!! important to make it reactive !!!
      this.localAllContacts = JSON.parse(JSON.stringify(newValue))  //..making a copy (by parsing JSON )
      
      console.log("allContacts have changed (watched by @ListPanelFilter-Contact) "+this.localAllContacts.length)
      
      // console.log(`Updating from ${oldValue} to ${newValue}`);
      // this.localSelectedContact = Object.assign({}, newValue)   //...make a copy of the object (even working with the original Object, it's needed) !!! important to make it reactive !!!???
      // this.localSelectedContact = newValue
    }
  }
  
  

}

// function filterByValue(array, string) {
//     return array.filter(o =>
//         Object.keys(o).some(k => o[k].toLowerCase().includes(string.toLowerCase())));
// }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>